<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                Confirm Order
            </span>
            <button mat-icon-button tabindex="-1" (click)="matDialogRef.close(false)" aria-label="Close dialog"
                type="button">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content>
        <div class="p-24 pb-0 m-0" fusePerfectScrollbar>
            <table class="checkout-table w-100-p">
                <tr>
                    <td class="font-weight-900">Company Name</td>
                    <td class="text-right">{{ myInfo.companyName }}</td>
                </tr>
                <tr>
                    <td class="font-weight-900">Shipper</td>
                    <td class="text-right">{{ order.shipperName }}</td>
                </tr>
                <tr>
                    <td class="font-weight-900">
                        {{ order.isNetPointShipper ? 'From NetPoint Location' : 'Shipper Address'}}</td>
                    <td class="text-right">{{ order.shipperAddress }}</td>
                </tr>
                <tr>
                    <td class="font-weight-900">Receiver</td>
                    <td class="text-right">{{ order.receiverName }}</td>
                </tr>

                <tr>
                    <td class="font-weight-900">
                        {{ order.isNetPointReceiver ? 'To NetPoint Location' : 'Receiver Address'}}</td>
                    <td class="text-right">{{ order.receiverAddress }}</td>
                </tr>

                <!-- <tr>
                    <td class="font-weight-900">Pickup Date</td>
                    <td class="text-right">{{ order.pickupDate | date }}</td>
                </tr> -->

 
                <tr>
                    <td class="font-weight-900">Commodity</td>
                    <td class="text-right">{{ order.commodityId | commodity:serviceTypeId | async }}</td>
                </tr>

                <tr>
                    <td class="font-weight-900">Number Of Pieces</td>
                    <td class="text-right">{{ order.quote.numberOfPieces }}</td>
                </tr>

                <tr>
                    <td class="font-weight-900">Shipment Value</td>
                    <td class="text-right">{{ order.quote.shipmentValue | number:'.2-2' }}
                        <span >{{currencyRef}}</span></td>
                </tr>
<!-- 
                <tr>
                    <td class="font-weight-900">Shipping Type</td>
                    <td class="text-right">{{ order.quote.shippingType }}</td>
                </tr> -->

                <tr>
                    <td class="font-weight-900">Weight</td>
                    <td class="text-right">{{ order.quote.weight | number:'.2-2' }} Kg</td>
                </tr>

                <tr *ngIf="order.quote.width && order.quote.height && order.quote.length">
                    <td class="font-weight-900">Dimension</td>
                    <td class="text-right">
                        {{ order.quote.length | number:'.2-2' }} cm x
                        {{ order.quote.width | number:'.2-2' }} cm x
                        {{ order.quote.height | number:'.2-2' }} cm
                    </td>
                </tr>

                <!-- <tr>
                    <td class="font-weight-900">Goods Description</td>
                    <td class="text-right"> {{ order.goodsDescription }}</td>
                </tr> -->

                <tr>
                    <td class="font-weight-900">Special Instructions</td>
                    <td class="text-right"> {{ order.specialInstructions }}</td>
                </tr>

            </table>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="m-0 p-24 dialog-footer" fxLayout="row" fxLayoutAlign="end center" align="end">
        <ng-container >
            <button mat-raised-button color="primary" class="mr-8" (click)="confirm()" aria-label="Confirm"
                [disabled]="payClicked"  matTooltip="Confirm">
                CONFIRM
            </button>

            <button mat-button class="ml-8" color="warn" (click)="matDialogRef.close('cancel')" aria-label="Cancel"
                [disabled]="payClicked"  matTooltip="Cancel">
                CANCEL
            </button>

         </ng-container>

     </mat-dialog-actions>
</div>